require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-the-next-frontier-of-inner-city-melbourne-living-is.json") })
        }
      }, "path---news-the-next-frontier-of-inner-city-melbourne-living-is");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-the-next-frontier-of-inner-city-melbourne-living-is!./.cache/json/news-the-next-frontier-of-inner-city-melbourne-living-is.json
// module id = 857
// module chunks = 231608221292675